import { Injectable, NgModule } from '@angular/core';
import { PreloadingStrategy, Route, RouterModule, Routes } from '@angular/router';
import { BaseLayoutComponent } from '@libraries/design-system';
import { Observable, of } from 'rxjs';
import { CanActivateApplyGuard, CanActivateChildGuard } from './guards';
import { CanActivateEligibleFundsGuard } from './guards/can-activate-eligible-funds.guard';

const routes: Routes = [
  {
    data: { context: 'application', preload: true },
    path: 'apply',
    loadChildren: () => import('./apply-v2/apply-v2.module').then((m) => m.ApplyV2Module),
    canActivate: [CanActivateApplyGuard],
  },
  {
    path: '',
    component: BaseLayoutComponent,
    children: [
      {
        path: 'prequal',
        loadChildren: () =>
          import('./prequal-questions/prequal-questions.module').then(
            (m) => m.PrequalQuestionsModule
          ),
        canActivateChild: [CanActivateChildGuard],
      },
      {
        path: 'ContractorApply',
        loadChildren: () =>
          import('./contractor-apply/contractor-apply.module').then((m) => m.ContractorApplyModule),
      },
      {
        path: 'eligible-funds',
        loadChildren: () =>
          import('./eligible-funds/eligible-funds.module').then((m) => m.EligibleFundsModule),
        canActivate: [CanActivateEligibleFundsGuard],
      },
      {
        path: '**',
        redirectTo: 'prequal',
      },
    ],
  },
];

@Injectable({ providedIn: 'root' })
export class PreloadSelectedModulesList implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<any> {
    return route.data?.preload ? load() : of(null);
  }
}

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadSelectedModulesList,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
